import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import SoundCloudPlayer from "../album-player/sound-cloud-player";
import SpotifyPlayer from "../album-player/spotify-player";
import * as styles from "./discography.module.css";

const Discography = () => (
  <section id="discography" className="section-wrapper">
    <h2 className="section-title">
      <a href="#discography">Discography</a>
    </h2>

    <SpotifyPlayer />

    <div className={styles.discographiesWrapper}>
      <div className={styles.discographyItem}>
        <a
          href="https://soundcloud.com/milkyhaze/sets/space-bass-ep-1"
          target="_blank"
        >
          <StaticImage
            src="../../images/discography/spacebass.png"
            alt="Spacebass Cover Art"
            placeholder="blurred"
          />
          <h3 className="font-bold">SPACEBASS (EP)</h3>
          <p>6 tracks, 21 minutes and 31 seconds</p>
        </a>
      </div>

      <div className={styles.discographyItem}>
        <a
          href="https://soundcloud.com/milkyhaze/griz-clozee-color-of-your-soul-milky-haze-remix-1"
          target="_blank"
        >
          <StaticImage
            src="../../images/discography/color_of_your_soul.png"
            alt="Color Of Your Soul Cover Art"
            placeholder="blurred"
          />
          <h3 className="font-bold">Color Of Your Soul</h3>
          <p>(Milky Haze Remix)</p>
          <p>GRiZ &amp; CloZee</p>
        </a>
      </div>

      <div className={styles.discographyItem}>
        <a
          href="https://soundcloud.com/milkyhaze/skrillex-noisia-josh-pan-dylan-brady-supersonic-milky-haze-remix-1"
          target="_blank"
        >
          <StaticImage
            src="../../images/discography/supersonic.png"
            alt="Supersonic Cover Art"
            placeholder="blurred"
          />
          <h3 className="font-bold">Supersonic</h3>
          <p>(Milky Haze Remix)</p>
          <p>Skrillex, Noisia, Josh Pan &amp; Dylan Brady</p>
        </a>
      </div>

      <div className={styles.discographyItem}>
        <a
          href="https://soundcloud.com/milkyhaze/clozee-jason-leech-farewell-milky-haze-remix"
          target="_blank"
        >
          <StaticImage
            src="../../images/discography/farewell.png"
            alt="Farewell Cover Art"
            placeholder="blurred"
          />
          <h3 className="font-bold">Farewell</h3>
          <p>(Milky Haze Remix)</p>
          <p>CloZee &amp; Jason Leech</p>
        </a>
      </div>

      <div className={styles.discographyItem}>
        <a
          href="https://soundcloud.com/milkyhaze/cromulon-razzmatazz-milky-haze-remix"
          target="_blank"
        >
          <StaticImage
            src="../../images/discography/razzmatazz.png"
            alt="Razzmatazz Cover Art"
            placeholder="blurred"
          />
          <h3 className="font-bold">Razzmatazz</h3>
          <p>(Milky Haze Remix)</p>
          <p>Cromulon</p>
        </a>
      </div>

      <div className={styles.discographyItem}>
        <a
          href="https://soundcloud.com/milkyhaze/clozee-maddy-oneal-zest-please-milky-haze-flip"
          target="_blank"
        >
          <StaticImage
            src="../../images/discography/zest_please.png"
            alt="Zest Please Cover Art"
            placeholder="blurred"
          />
          <h3 className="font-bold">Zest Please</h3>
          <p>(Milky Haze Flip)</p>
          <p>Clozee &amp; Maddy O'Neal</p>
        </a>
      </div>

      <div className={styles.discographyItem}>
        <a
          href="https://soundcloud.com/milkyhaze/milkyhaze-valentines-mixtape"
          target="_blank"
        >
          <StaticImage
            src="../../images/discography/valentines_mixtape.png"
            alt="Valentine's Mixtape Cover Art"
            placeholder="blurred"
          />
          <h3 className="font-bold">Valentine's Mixtape</h3>
          <p>(Mixtape)</p>
        </a>
      </div>

      <div className={styles.discographyItem}>
        <a
          href="https://soundcloud.com/milkyhaze/tha-dark-light?utm_source=clipboard"
          target="_blank"
        >
          <StaticImage
            src="../../images/discography/the_dark_light.png"
            alt="The Dark Light Cover Art"
            placeholder="blurred"
          />
          <h3 className="font-bold">The Dark Light</h3>
          <p>(Single)</p>
        </a>
      </div>
    </div>
  </section>
);

export default Discography;
